import { withNamespaces } from 'react-i18next';
import {
    Button,
    Card,
    CardBody,
} from 'reactstrap';

const Notes = ({
    notes = [],
    t,
}) => {
    return (
        <Card>
            <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{t('Notes')}</h5>
                    <Button className="p-0" color="link" size="sm" type="button">
                        {t('Add note')}
                    </Button>
                </div>

                {notes.map((note) => (
                    <div className="d-flex align-items-start" key={note.id}>
                        <div className="avatar-xs me-2">
                            <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                                {note.initials}
                            </span>
                        </div>

                        <div className="flex-grow-1">
                            <div>
                                <b className="me-2">{note.author}</b>
                                <small className="text-muted">{note.date}</small>
                            </div>
                            <span>{t(note.content)}</span>
                        </div>

                        <Button aria-label={t('Note actions')} className="border-0" color="secondary" outline>
                            <i className="ri-more-2-fill" />
                        </Button>
                    </div>
                ))}
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    Notes
);
